module.exports = __webpack_public_path__ + "static/media/teamOne.562c0ef3.webp";